import { render, staticRenderFns } from "./BodyStageUserType.vue?vue&type=template&id=15cd213c&scoped=true&"
import script from "./BodyStageUserType.vue?vue&type=script&lang=js&"
export * from "./BodyStageUserType.vue?vue&type=script&lang=js&"
import style0 from "./BodyStageUserType.vue?vue&type=style&index=0&id=15cd213c&lang=scss&scoped=true&"
import style1 from "./BodyStageUserType.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd213c",
  null
  
)

export default component.exports